/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserLogin = {
    properties: {
        username: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        password: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        operatorId: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
    },
};